import { IEwtCounts } from '../ewt-counts'
import { IEwtSummary } from '../ewt-summary'
import { ITargetedChainEnd } from "../targets/targeted-chain-end"
import { IUnmatchedPair } from "../targets/unmatched-pair"

export interface IHighDeclineTargetedChainEnd extends ITargetedChainEnd {
    [index: string]: string | boolean | number | IEwtCounts | IEwtSummary,
    patientType: string,
    actualWaitTimeDays: number,
    epletPreference: string,
    withinTwoWeeks: boolean
}

export interface IHighDeclineUnmatchedPair extends IUnmatchedPair {
    [index: string]: string | boolean | number | IEwtCounts | IEwtSummary,
    patientType: string,
    actualWaitTimeDays: number,
    epletPreference: string,
    withinTwoWeeks: boolean
}